'use strict';

import {Redoc} from './components/index';
export var init = Redoc.init;

window.Redoc = Redoc;
Redoc.autoInit();
